/* eslint-disable import/prefer-default-export */
export const dataQa = {
    wrapper: 'bloko-custom-select-wrapper',
    select: 'bloko-custom-select-select',
    searchInput: 'bloko-custom-select-search-input',
    option: 'bloko-custom-select-option',
    hiddenInput: 'bloko-custom-select-hidden-select',
    optionList: 'bloko-custom-select-option-list',
};
